const doc = [({"da":({"js":({"nemoa":({"activities":({"show":({"nav":({"overview":"Oversigt", "live":"Live", "politics":"Politik", "election":"Valg"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;